import type { AvailabilitySchema } from "@/types/ingestedProduct";

export type SkuStoreStockState = "available" | "out_of_stock" | "unavailable";

/**
 * Mirrors the backend: only tracked, `deny`-policy stock with a known
 * quantity <= 0 is out of stock. Zero, negative or unknown quantity is
 * otherwise still available when the source says so.
 */
export function resolveStockState(
  availability: AvailabilitySchema,
): SkuStoreStockState {
  const { is_available, inventory_tracked, inventory_policy, quantity } =
    availability;
  if (!is_available) {
    return "unavailable";
  }
  if (
    inventory_tracked === true &&
    inventory_policy === "deny" &&
    quantity != null &&
    quantity <= 0
  ) {
    return "out_of_stock";
  }
  return "available";
}
